import api from "./axiosConfig";

export type AffiliateNetwork =
  | "partnerAds"
  | "adTraction"
  | "daisyCon"
  | "tradeDoubler"
  | "cj"
  | "awin"
  | "impact";

export const AFFILIATE_NETWORKS: AffiliateNetwork[] = [
  "partnerAds",
  "adTraction",
  "daisyCon",
  "tradeDoubler",
  "cj",
  "awin",
  "impact",
];

export const AFFILIATE_NETWORK_LABELS: Record<AffiliateNetwork, string> = {
  partnerAds: "PartnerAds",
  adTraction: "Adtraction",
  daisyCon: "Daisycon",
  tradeDoubler: "TradeDoubler",
  cj: "CJ",
  awin: "Awin",
  impact: "Impact",
};

export interface PartnerNetworkReportRow {
  businessId: string;
  businessName: string;
  startDate: string | null;
  endDate: string | null;
  profileViews: number;
  transactionCount: number;
}

export interface PartnerNetworkReportResponse {
  byNetwork: Record<AffiliateNetwork, PartnerNetworkReportRow[]>;
}

export const getPartnerNetworkReport =
  async (): Promise<PartnerNetworkReportResponse> => {
    try {
      const response = await api.post(
        "/business-account/get-partner-network-report",
        {}
      );
      return response.data;
    } catch (error) {
      console.error("Getting partner network report error:", error);
      throw error;
    }
  };
